// 工作台路由
const dashboard = {
    path: 'dashboard',
    component: () => import('@/components/RouterView'),
    meta: {title: '个人中心'},
    redirect: '/manage/dashboard',
    children: [
        {
            path: '',
            component: () => import('@/views/manage/dashboard'),
            meta: {title: '我的工作台', isTitle: true}
        },
        {
            path: 'notice/:id',
            component: () => import('@/views/manage/dashboard/notice'),
            meta: {title: '系统公告'}
        }
    ]
};

export default dashboard;
